import { useParams, useNavigate } from 'react-router-dom';
import { usePost } from '../hooks/usePost';
import { usePostStatus } from '../hooks/usePostStatus';
import { useAuthContext } from '../../../components/AuthProvider';
import PostActions from '../components/PostActions';
import ReactMarkdown from 'react-markdown';

export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { data: post, isLoading, error } = usePost(slug || '');
  const { user } = useAuthContext();
  const { updateStatus, isUpdating } = usePostStatus(post?.id || '');

  if (isLoading) {
    return <div className="text-center py-8">加载中...</div>;
  }

  if (error || !post) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-semibold text-gray-900">文章不存在</h2>
        <p className="mt-2 text-gray-600">该文章可能已被删除或移动</p>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 text-indigo-600 hover:text-indigo-500"
        >
          返回上一页
        </button>
      </div>
    );
  }

  const isAuthor = user?.id === post.author_id;

  return (
    <article className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm">
      <header className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-3xl font-bold">{post.title}</h1>
          <PostActions
            post={post}
            isAuthor={isAuthor}
            onStatusChange={(status) => updateStatus({ status })}
            isStatusUpdating={isUpdating}
          />
        </div>
        <div className="text-gray-600">
          {new Date(post.created_at).toLocaleDateString()}
        </div>
      </header>
      
      <div className="prose max-w-none">
        <ReactMarkdown>{post.content}</ReactMarkdown>
      </div>
    </article>
  );
}